export default __webpack_public_path__ + "static/media/analytics-shape-bg.c25653ad.png";